import { useEffect } from "react";
import { supabase } from "../supabaseClient";

/**
 * Handles background tab throttling:
 * - Pause token auto-refresh when tab is hidden
 * - Resume + force a session fetch when tab becomes visible or window gains focus
 */
export default function useAuthVisibilityRefresh() {
  useEffect(() => {
    let mounted = true;

    const handleVisibility = async () => {
      if (document.visibilityState === "visible") {
        // Resume auto refresh & re-check the session
        (supabase.auth as any).startAutoRefresh?.();
        try {
          await supabase.auth.getSession();
          if (!mounted) return;
          // optional: you can dispatch this to your auth context if desired
        } catch {/* no-op */}
      } else {
        (supabase.auth as any).stopAutoRefresh?.();
      }
    };

    const handleFocus = async () => {
      try {
        await supabase.auth.getSession();
        if (!mounted) return;
        // optional: you can dispatch this to your auth context if desired
      } catch {/* no-op */}
    };

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("focus", handleFocus);

    // Align with current state
    handleVisibility();

    return () => {
      mounted = false;
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("focus", handleFocus);
    };
  }, []);
}
